export default __webpack_public_path__ + "static/course-477b939e56888048d3efefa137290087.jpg";